import classes from './Loaders.module.css';

interface IMainLoader {
  container?: string;
  withContainer?: boolean;
}
export const MainLoader: React.FC<IMainLoader> = ({
  container,
  withContainer,
}) => {
  const loader = (
    <div className={classes.webyLoaderBox}>
      <div className={classes.webyLoader}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
  if (withContainer) {
    return (
      <div
        className={`${classes.loaderContainer} ${container ? container : ''}`}
      >
        {loader}
      </div>
    );
  }
  return loader;
};
